import React from 'react';
import moment from 'moment';
import { conditionHelper } from '@laigu/component';

const { range } = conditionHelper;
const EditableContext = React.createContext();
const defaultEndedOnDate = moment().endOf('day');
const defaultEndedOnRangeDate = [
  moment()
    .startOf('day')
    .subtract(6, 'day'),
  moment().endOf('day')
];

const defaultFilterParam = {
  ended_on: {
    value: defaultEndedOnRangeDate,
    condition: range.value
  }
};

export { EditableContext, defaultEndedOnDate, defaultEndedOnRangeDate, defaultFilterParam };
